import { Tooltip } from "react-tooltip";
import { useTranslation } from "react-i18next";
import { useMemo } from "react";
import { useTheme } from "@hooks/useTheme";

const GenesisSyncInfoTooltip = ({ "data-testid": dataTestId = "genesis-sync-info-tooltip" }) => {
  const { t } = useTranslation();
  const { colors } = useTheme();

  // Unique tooltip id in case this component is used multiple times
  const tooltipId = useMemo(
    () => `genesis-sync-tooltip-${Math.random().toString(36).slice(2, 9)}`,
    []
  );

  return (
    <>
      <button
        type="button"
        data-testid={`${dataTestId}-trigger`}
        className={`ml-2 mb-0.5 h-5 w-5 ${colors.textComparisonLink} ${colors.hoverTextComparisonLink} flex items-center justify-center focus:outline-none`}
        data-tooltip-id={tooltipId}
      >
        <svg
          data-testid={`${dataTestId}-icon`}
          className="h-5 w-5"
          fill="currentColor"
          viewBox="0 0 20 20"
          aria-hidden="true"
        >
          <path
            fillRule="evenodd"
            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
            clipRule="evenodd"
          />
        </svg>
      </button>

      <Tooltip
        id={tooltipId}
        data-testid={`${dataTestId}-tooltip`}
        place="top"
        className={`${colors.bgTooltip} ${colors.textTooltip} !text-xs !rounded-lg !px-4 !py-3 !max-w-[480px] !min-w-[320px] !z-50 !leading-relaxed`}
        style={{
          backgroundColor: colors.headerTooltipBackgroundColor,
          color: colors.headerTooltipTextColor,
          fontSize: "12px",
          borderRadius: "8px",
          padding: "12px 16px",
          maxWidth: "480px",
          minWidth: "320px",
          zIndex: 50,
          lineHeight: 1.5,
        }}
      >
        <div data-testid={`${dataTestId}-tooltip-body`}>
          <p className="mb-2" data-testid={`${dataTestId}-tooltip-main`}>
            {t(
              "preferences.genesis-sync-help-main",
              "Sync components and licenses information from Genesis."
            )}
          </p>
          <p className="mb-1" data-testid={`${dataTestId}-tooltip-sync-now`}>
            <span className="font-semibold">
              {t("preferences.genesis-sync-help-sync-now-label", "Sync Now:")}
            </span>{" "}
            {t(
              "preferences.genesis-sync-help-sync-now-desc",
              "Continue the synchronization from the last completed point."
            )}
          </p>
          <p data-testid={`${dataTestId}-tooltip-full-sync`}>
            <span className="font-semibold">
              {t("preferences.genesis-sync-help-full-sync-label", "Full Sync:")}
            </span>{" "}
            {t(
              "preferences.genesis-sync-help-full-sync-desc",
              "Restart the synchronization and re-import all components and licenses from the beginning."
            )}
          </p>
        </div>
      </Tooltip>
    </>
  );
};

export default GenesisSyncInfoTooltip;

